import { render, staticRenderFns } from "./FactRetirementPlan.vue?vue&type=template&id=629708ec&scoped=true&"
import script from "./FactRetirementPlan.vue?vue&type=script&lang=js&"
export * from "./FactRetirementPlan.vue?vue&type=script&lang=js&"
import style0 from "./FactRetirementPlan.vue?vue&type=style&index=0&id=629708ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629708ec",
  null
  
)

export default component.exports